module.exports = __webpack_public_path__ + "static/media/farm-bottoms.a14c09b8.jpg";